<template>
<div class="p-8 login-tabs-container">

  <h4 class="mb-4">{{ $t('message.register.header') }}</h4>
  <div class="vx-card__title my-10 w-full" v-if="!smsCode">
    <label class="w-full flex justify-between">
      <div class="w-1/4 text-right leading-form pr-2">{{ $t('message.register.enterPhoneLabel') }}</div>
      <vs-input
        name="phone" @input="$emit('update:phone', $event)"
        :placeholder="$t('message.register.enterPhone')"
        :value="phone" class="w-3/4"/>
    </label>
  </div>

  <div class="vx-card__title my-10 w-full" v-if="smsCode">
    <label class="w-full flex justify-between">
      <div class="w-1/4 text-right leading-form pr-2">{{ $t('message.register.enterCodeLabel') }}</div>
      <vs-input
        name="phone" v-model="smsCode"
        :placeholder="$t('message.register.enterCode')" class="w-3/4"/>
    </label>
  </div>

  <div class="vx-card__title mb-4 mt-10 0" v-if="!smsCode">
    <span v-html="$t('message.register.info')" />
    <a href="javascript: void(0)" @click="agrement = true">
      {{ $t('message.register.infoHref') }}
    </a>
  </div>

  <div class="vx-card__title mb-4" v-if="!confirmed">
    <vs-button @click="getSmsAction" line-origin="center"
               color="primary" type="gradient" class="mt-8">
      {{ $t('message.register.nextPhone') }}
    </vs-button>
  </div>
  <div class="vx-card__title mb-4" v-if="confirmed">
    <vs-button @click="$emit('next-step')" line-origin="center"
               color="primary" type="gradient" class="mt-8">
      {{ $t('message.register.nextStepButton') }}
    </vs-button>
  </div>

  <vs-popup class="holamundo" :title="$t('message.register.userAgrement')" :active.sync="agrement">
    <div class="mb-4">
      <span v-html="$t('message.register.userAgrementText')" />
    </div>
  </vs-popup>

</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'RegistrationPhone',
  props: {
    'phone':{}
  },
  data: () => ({
    agrement: false,
    confirmed: false,
    smsCodeSend: false,
    smsCode: null
  }),
  methods: {
    ...mapActions('onboarding', ['getSms']),
    async getSmsAction () {
      this.smsCodeSend = await this.getSms()
    }
  }
}
</script>

<style scoped>

</style>
